import styles from './WinnerChip.module.scss';

export type WinnerChipProps = {
  label?: string;
  containerClassName?: string;
  chipClassName?: string;
};

export const WinnerChip = ({ label, containerClassName, chipClassName }: WinnerChipProps) => {
  return (
    <p className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      <span className={`${styles.chip} ${chipClassName}`}>{label ? label : 'Vincente'}</span>
    </p>
  );
};
